import { render, staticRenderFns } from "./tenant_config_packages.vue?vue&type=template&id=2b41856c&scoped=true&"
import script from "./tenant_config_packages.vue?vue&type=script&lang=js&"
export * from "./tenant_config_packages.vue?vue&type=script&lang=js&"
import style0 from "./tenant_config_packages.vue?vue&type=style&index=0&id=2b41856c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41856c",
  null
  
)

export default component.exports